/**
 * Picks the next exercise still to do: the first unfinished one after the current exercise in
 * list order, then (once the end is reached) the first unfinished one before it. Skipping an
 * exercise therefore never sends the student straight back to it.
 */
export function pickNextExercise<T extends { id: string }>(
  exercises: T[],
  currentId: string | undefined,
  isDone: (exercise: T) => boolean,
): T | undefined {
  const currentIndex = exercises.findIndex((exercise) => exercise.id === currentId);
  const following = exercises.slice(currentIndex + 1);
  const preceding = currentIndex > 0 ? exercises.slice(0, currentIndex) : [];
  return [...following, ...preceding].find((exercise) => !isDone(exercise));
}
